import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedReceitasData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/receitas?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllReceitasData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/receitas?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.empresa}"`,
    data.plataforma != null ? `"${data.plataforma}"` : '',
    `"${data.tipoAssinatura}"`,
    `"${data.orderId}"`,
    `"${toDate(data.expiraEm)}"`,
    `"${data.status}"`,
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataHoraCompraInicial: toDateFromPtBr(options.creationInitialDate),
  dataHoraCompraFinal: toDateFromPtBr(options.creationEndDate),
  expiraEmInicial: toDateFromPtBr(options.closingInitialDate),
  expiraEmFinal: toDateFromPtBr(options.closingEndDate),
  finalPeriodoGratuitoInicial: toDateFromPtBr(options.freeInitialDate),
  finalPeriodoGratuitoFinal: toDateFromPtBr(options.freeEndDate),
  status: options.status,
});
